import React from 'react';
import { CheckingBoxIcon, DefaultText } from '@guryou/html-components';
import { dealTokens } from 'components/shared';

const CheckboxInfoContainer = ({ text }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: dealTokens.space[3] }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          width: 22,
          height: 22,
          marginTop: 1,
          borderRadius: dealTokens.radius.pill,
          background: dealTokens.color.successSoft,
        }}
      >
        <CheckingBoxIcon htmlColor={dealTokens.color.success} style={{ fontSize: 14 }} />
      </div>
      <DefaultText fontSize="0.92rem" lineHeight="1.5">
        {text}
      </DefaultText>
    </div>
  );
};

export default CheckboxInfoContainer;
